import React, { Component } from "react";
import {
  InputGroup,
  InputGroupAddon,
  Input,
  Row,
  Col,
  Button,
  Table
} from "reactstrap";
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import Collapsible from 'react-collapsible';
import BlockUi from 'react-block-ui';
import Pagination from "react-js-pagination";
import { BACLUONG_LIST_SUCCESS } from './constants'
import * as bacLuongAction from './actions'
import { storedb } from '../../views/client/storedb'
import DisplayRecordText from "../controls/_DisplayRecordText"
import { BtnPermissions, BtnType } from '../../lib/BtnPermissions';
import { ButtonExt } from "../controls/ButtonExt"

class BacLuong extends Component {
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      storeId: dbContext.getStoreId(),
      item: {},
      list: [],
      TrangThaiId: '',
      keyword: '',
      per_page: 20,
      page: 1,
      total_record: 0
    };
  }
  handlePageChange = (pageNumber) => {
    let page = parseInt(pageNumber || 1)
    return this.setState({ page }, this.fetchList);
  }
  handleSearchChange = (name, e, value) => {
    switch (name) {
      case "keyword":
        this.setState({ keyword: e.target.value });
        break;
      default:
        break;
    }
  }
  handleSelectChange = (name, selectedOption) => {
    switch (name) {
      case "TrangThai":
        this.setState({ TrangThaiId: selectedOption.target.value })
        break;
      default:
        break;
    }
  }
  fetchList = () => {
    const { bacLuongListRequest } = this.props

    var requestData = {
      StoreId: this.state.storeId,
      keyword: this.state.keyword,
      IsActive: this.state.TrangThaiId,
      page: this.state.page,
      per_page: this.state.per_page
    };
    return bacLuongListRequest(requestData);
  }
  search = () => {
    if (this.props.bacLuong.listRequesting) {
      return false;
    }
    return this.fetchList()
  }
  refresh = () => {
    this.setState({
      storeId: this.state.storeId,
      keyword: '',
      TrangThaiId: '',
      page: this.state.page,
      per_page: this.state.per_page
    }, () => {
      if (this.props.bacLuong.listRequesting) {
        return false;
      }
      return this.fetchList()
    })
  }
  onChangeItem = (itemPerPage) => {
    this.setState({ per_page: itemPerPage }, () => {
      this.search();
    });
  }
  EditBacLuongItem = (item) => {
    this.props.history.push('/bacluong-edit?bacluong=' + (item.BacLuongId || ""));
  }
  viewBacLuongItem = (e, item) => {
    e.preventDefault()
    this.props.history.push('/bacluong-edit?bacluong=' + item.BacLuongId);
  };
  EditBacLuongUserItem = () => {
    this.props.history.push('/bacluong-user');
  }

  componentDidMount() {
    this.fetchList();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.bacLuong.type == BACLUONG_LIST_SUCCESS) {
      let { list, item } = nextProps.bacLuong;
      this.setState({
        page: item.page,
        per_page: item.per_page,
        total_record: item.total_record,
        list: list
      });
    }
  }
  render() {
    const {
      handleSubmit,
      bacLuong: {
        listRequesting,
        list
      },
    } = this.props
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={listRequesting} >
          <div>
            <Collapsible trigger="Tìm kiếm..." open={true}>
              <Row>
                <Col sm="8" className="mb-2">
                  <InputGroup size="md">
                    <InputGroupAddon addonType="prepend" autoComplete="off" >Tên bậc lương</InputGroupAddon>
                    <Input name="keyword" autoComplete="off" value={this.state.keyword} onChange={this.handleSearchChange.bind(this, "keyword")} />
                  </InputGroup>
                </Col>
                <Col sm="4" className="mb-2">
                  <InputGroup size="md">
                    <InputGroupAddon addonType="prepend">Trạng thái</InputGroupAddon>
                    <select className="form-control" value={this.state.TrangThaiId} onChange={this.handleSelectChange.bind(this, "TrangThai")}>
                      <option value="">Trạng thái</option>
                      <option value={1}>Hoạt động</option>
                      <option value={0}>Ngừng hoạt động</option>
                    </select>
                  </InputGroup>
                </Col>
              </Row>
            </Collapsible>
          </div>
          <div className="mt-2 bg-white">
            <div className="w-100 mb-2">
              <Button size="md" color="success" className="pull-left mr-1"
                onClick={handleSubmit(this.search)}><i className="fa fa-search"></i> Tìm kiếm</Button>
              <ButtonExt btnClass="mr-1"
                color="primary"
                iconClass="fa-plus"
                displayText="Thêm mới"
                btnClick={() => this.EditBacLuongItem({})}
                permission={BtnPermissions.BacLuong.ADD_OR_UPDATE} />
              <ButtonExt btnClass="mr-1"
                color="success"
                iconClass="fa-users"
                displayText="Phân nhân viên"
                btnClick={() => this.EditBacLuongUserItem({})}
                permission={BtnPermissions.BacLuong.ADD_USERS} />
            </div>
            <div className="w-100">
              <DisplayRecordText
                itemsCountPerPage={this.state.per_page}
                onChangeItem={this.onChangeItem}
              />
              <Table hover responsive className="table-outline mb-0 d-sm-table table-sm">
                <thead className="thead-default">
                  <tr>
                    <th scope="col" width="50" className="text-center">#</th>
                    <th scope="col" className="text-left">Tên bậc lương</th>
                    <th scope="col" className="text-right">Lương cơ bản</th>
                    <th scope="col" className="text-center">Trạng thái</th>
                    <th scope="col" width="20" className="text-center">Sửa</th>
                  </tr>
                </thead>
                <tbody>
                  {list && !!list.length && (
                    list.map((res, idx) => (
                      <tr key={idx + 1}>
                        <td className="text-center">{idx + 1}</td>
                        <td className="text-left"><a href='#' onClick={(e) => this.viewBacLuongItem(e, res)}>{res.Ten}</a> </td>
                        <td className="text-right">{res.LuongCoBan.toLocaleString()}</td>
                        <td className="text-center">
                          {res.IsActive == 0 ? <span className="text-danger"><i className="fa fa-close"></i></span> : <span className="text-success"><i className="fa fa-check"></i></span>}
                        </td>
                        <td scope="row" className="text-center">
                          <ButtonExt
                            btnClass="text-primary mr-1"
                            iconClass="fa-edit fa-lg"
                            btnType={BtnType.ButtonLink}
                            btnClick={() => this.EditBacLuongItem(res)}
                            permission={BtnPermissions.BacLuong.ADD_OR_UPDATE} />
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
                <tfoot>
                  <tr>
                    <td colSpan="5">
                      <span className="text-success mr-2"><i className="fa fa-check"></i> = Đang hoạt động</span>
                      <span className="text-danger"><i className="fa fa-close"></i> = Dừng hoạt động</span>
                    </td>
                  </tr>
                </tfoot>
              </Table>
              {this.state.total_record > this.state.per_page && (
                <Pagination
                  activePage={this.state.page}
                  itemsCountPerPage={this.state.per_page}
                  totalItemsCount={this.state.total_record}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange}
                />
              )}
            </div>
            <div className="clearfix"></div>
          </div>
        </BlockUi>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  bacLuong: state.bacLuong,
  client: state.client,
})
const connected = connect(mapStateToProps, {
  bacLuongListRequest: bacLuongAction.bacLuongListRequest,
  bacLuongUpdateRequest: bacLuongAction.bacLuongUpdateRequest,
})(BacLuong)
const formed = reduxForm({
  form: 'bacLuong',
})(connected)
export default formed;



// WEBPACK FOOTER //
// ./src/views/BacLuong/BacLuong.js